var vendorObjects = [{
	"Brand": "AdCraft",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Admiral_Craft_Logo_1200x_6674f0b8-db17-4f38-b854-c1c27fa18c0f.png?v=1691695208"
}, {
	"Brand": "Axis",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/axis-logo.png?v=1691695203"
}, {
	"Brand": "Black Diamond",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/black-diamond-brand.png?v=1691695209"
}, {
	"Brand": "Blue Air",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/BLUEAIRRRR-1.png?v=1691695203"
}, {
	"Brand": "Bunn",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/bunn-logo-vector-e1593116542531.png?v=1691695203"
}, {
	"Brand": "Centerline",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Centerline_byTraulsen_pmsColor.png?v=1691695204"
}, {
	"Brand": "Chef AAA",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/tasCHqTw_400x400_1.jpg?v=1691695208"
}, {
	"Brand": "Dukers",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/dukerslogo_copyright_1.png?v=1691695210"
}, {
	"Brand": "Elite Kitchen Supply",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/313429747_102855359305639_1640198093978025889_n.jpg?v=1691695210"
}, {
	"Brand": "Everest",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/logo_200.webp?v=1691695203"
}, {
	"Brand": "Excellence Industries",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/ei-logo-OGP.png?v=1691695210"
}, {
	"Brand": "German Knife",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/German_Knife.png?v=1691695208"
}, {
	"Brand": "Gk & Radiance",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Radiance.png?v=1691695209"
}, {
	"Brand": "Green World",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Green_World.png?v=1691695209"
}, {
	"Brand": "Grista",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Grista.png?v=1691695210"
}, {
	"Brand": "Hobart",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/hobart_logo_hr.webp?v=1691695206"
}, {
	"Brand": "Hoshizaki",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Hoshizaki_logo_right2.png?v=1691695210"
}, {
	"Brand": "Hydra Kool",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Hydra_Kool.webp?v=1691695205"
}, {
	"Brand": "IKON",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/IKON.webp?v=1691695205"
}, {
	"Brand": "ITV",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/ITV.png?v=1691695202"
}, {
	"Brand": "Ice-O-Matic",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Iceomatic-Logo-e1610640856891.jpg?v=1691695207"
}, {
	"Brand": "Icetro",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Icetro.jpg?v=1691695206"
}, {
	"Brand": "Jackson",
	"image": "https://cdn.shopify.com/s/files/1/0590/3145/3880/files/Jackson.jpg?v=1691695210"
}, {
	"Brand": "Jet-Tech",
	"image": ""
}, {
	"Brand": "KEENON",
	"image": ""
}, {
	"Brand": "KWS",
	"image": ""
}, {
	"Brand": "Kool-It",
	"image": ""
}, {
	"Brand": "Maxx Cold",
	"image": ""
}, {
	"Brand": "Migali",
	"image": ""
}, {
	"Brand": "NAFCOOL",
	"image": ""
}, {
	"Brand": "Omcan",
	"image": ""
}, {
	"Brand": "Osion",
	"image": ""
}, {
	"Brand": "Paladin",
	"image": ""
}, {
	"Brand": "Primo",
	"image": ""
}, {
	"Brand": "Saba",
	"image": ""
}, {
	"Brand": "Sierra",
	"image": ""
}, {
	"Brand": "TRUE",
	"image": ""
}, {
	"Brand": "Thunderbird",
	"image": ""
}, {
	"Brand": "Turbo Air",
	"image": ""
}, {
	"Brand": "U-Star",
	"image": ""
}, {
	"Brand": "Warranty",
	"image": ""
}]